module.exports = __webpack_public_path__ + "vuejs.png?cd42017bc5692ab61cea1bcd9ba8c763";